import { render, staticRenderFns } from "./PunishList.vue?vue&type=template&id=49963aae&scoped=true"
import script from "./PunishList.vue?vue&type=script&lang=ts"
export * from "./PunishList.vue?vue&type=script&lang=ts"
import style0 from "./PunishList.vue?vue&type=style&index=0&id=49963aae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49963aae",
  null
  
)

export default component.exports